export default __webpack_public_path__ + "static/media/The Art of Eastern Riding.57f542ee.jpg";